import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { CommonService } from 'src/app/Services/Common/common.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
declare var $: any;

@Component({
  selector: 'app-docupload',
  templateUrl: './docupload.component.html',
  styleUrls: ['./docupload.component.css']
})
export class DocuploadComponent implements OnInit {
  WebAPImasteruri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  DocForm: FormGroup;

  FileList: any;
  StoredFileName: string = "";
  constructor(
    private formBuilder: FormBuilder,
    private property: PropertiesService,
    public commonService: CommonService,
    private http: HttpClient,
    private httpRequestService: HttpRequestService,
    private alert: AlertDialogService,
    private route: ActivatedRoute
  ) { this.createForm(); }

  createForm() {
    this.DocForm = this.formBuilder.group({
      Type:[]
    });
  }

  ngOnInit(): void {
    this.FileList = [];

  }

  // Save() {
  //   if (this.property.roleId == this.property.DefaultRoleId) {
  //     var frmObj = this.EmployeeForm.getRawValue();

  //     if (!frmObj.PhotoURL) {
  //       delete frmObj.PhotoURL;
  //     }

  //     if (this.StoredFileName) {
  //       frmObj.PhotoURL = this.StoredFileName;
  //     }

  //     this.httpRequestService.postBSS(this.WebAPImasteruri + "/HR/Update_EmployeeMaster", frmObj).then((response: any) => {

  //       if (response.status == 200) {
  //         if (response.result.Table[0].Number) {
  //           this.alert.openSnackBar(response.result.Table[0].Message + ' ' + response.result.Table[0].Number, '1');
  //         } else {
  //           this.alert.openSnackBar(response.result.Table[0].Message, '1');
  //         }
  //         this.Clear();
  //       } else if (response.status == 400) {
  //         this.alert.openSnackBar(response.result, '');
  //       }
  //     }, (error: any) => {
  //     });
  //   } else {
  //     this.alert.openSnackBar('Access Denied', '');
  //   }
  // }

  Clear() {
    this.DocForm.reset();
    this.DocForm.enable();
    this.FileList = [];
  }

  onHBLFileSelected(event) {
    let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    this.imageUpload(files);
  }
  imageUpload(file) {
    var formData = new FormData();
    for (let i = 0; i < file.length; i++) {
      // var fileExtension = '.' + file[i].name.split('.').pop();
      // const strbval = 'Emp_' + Math.random().toString(36).substring(7) + new Date().getTime() + fileExtension;
      Object.defineProperty(file[i], 'name', {
        writable: true,
        // value: strbval
        value: file[i].name
      });
      formData.append('fileUpload', file[i]);
    }

    this.FileList = [];

    var frmObj = this.DocForm.getRawValue();

    this.http.post(this.WebAPImasteruri + "/FileStorage/uploadFileHR?FolderName=" + 'EMS/Docs/'+frmObj.Type, formData).subscribe((response: any) => {
      if (response) {
        let StoredFileName = response.result.Table1[0].StoredFileName;
        let FileName = response.result.Table1[0].FileName;
        this.StoredFileName = StoredFileName;
        // alert(StoredFileName);
        // response.result.Table1.forEach(eleme => {

        //   eleme.isActive = 1;

        //   this.FileList.push(eleme);
        // });
      } else if (!response) {
        this.alert.openSnackBar('Error Occured While Document Upload', '');
      }
    }, (error: any) => {
      console.log('imageUpload save Error Occured', error);
    });
  }

}
